import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import '../styles/Gallery.css';
import galleryHero from '../assets/images/home.jpg';

// Import ALL images
import homeImg from '../assets/images/home.jpg';
import exterior from '../assets/images/exterior.jpg';
import entrance from '../assets/images/entrance.jpg';

// Room paired images (from your Rooms page) - UPDATED NAMES
import baphuthiMakholokoe from '../assets/images/Baphuthi&Makholokoe Room.jpg';
import makhoakhoaBasia from '../assets/images/Makhoakhoa&Basia Room.jpg';
import batlokoaBafokeng from '../assets/images/Batlokoa&Bafokeng Room.jpg';
import bataungBakoena from '../assets/images/Bataung&Bakoena.jpg';

// Room detail images (ONLY for All Photos - NOT for Rooms filter)
import baphuthi from '../assets/images/baphuthi.jpg';
import baphuthii from '../assets/images/baphuthii.jpg';
import bap from '../assets/images/bap.jpg';
import baphuthimakhoakhoa from '../assets/images/baphuthimakhoakhoa.jpg';
import makhoa from '../assets/images/makhoa.jpg';
import makhoakhoa from '../assets/images/makhoakhoa.jpg';
import makhoablack from '../assets/images/makhoablack.jpg';
import blackdoor from '../assets/images/blackdoor.jpg';
import blackshower from '../assets/images/blackshower.jpg';
import makholokoebed from '../assets/images/makholokoebed.jpg';
import makholo from '../assets/images/makholo.jpg';
import makholokoetv from '../assets/images/makholokoetv.jpg';
import basiatv from '../assets/images/basiatv.jpg';
import bathtub from '../assets/images/bathtub.jpg';
import basia from '../assets/images/basia.jpg';
import roomview from '../assets/images/roomview.jpg';
import tv from '../assets/images/tv.jpg';
import bedside from '../assets/images/bedside.jpg';

const Gallery = () => {
    const [selectedImage, setSelectedImage] = useState(null);
    const [filter, setFilter] = useState('all');

    // Gallery images with UPDATED TITLES
    const images = [
        // ===== ROOM PAIRED IMAGES (4 images for 8 rooms) =====
        // These appear in BOTH "All Photos" AND "Rooms" filter
        { id: 1, src: baphuthiMakholokoe, category: 'rooms', title: 'Baphuthi & Bakubung Rooms', showInRooms: true, showTitle: true },
        { id: 2, src: makhoakhoaBasia, category: 'rooms', title: 'Batsoeneng & Basia Rooms', showInRooms: true, showTitle: true },
        { id: 3, src: batlokoaBafokeng, category: 'rooms', title: 'Batloung & Bafokeng Rooms', showInRooms: true, showTitle: true },
        { id: 4, src: bataungBakoena, category: 'rooms', title: 'Bataung & Bakoena Rooms', showInRooms: true, showTitle: true },
        
        // ===== GUEST HOUSE EXTERIOR PHOTOS =====
        // These appear in BOTH "All Photos" AND "Guest House" filter
        { id: 5, src: exterior, category: 'exterior', title: 'Guest House Exterior', showInExterior: true, showTitle: true },
        { id: 6, src: entrance, category: 'exterior', title: 'Guest House Entrance', showInExterior: true, showTitle: true },
        { id: 7, src: homeImg, category: 'exterior', title: 'Guest House Front View', showInExterior: true, showTitle: true },
        
        // ===== ADDITIONAL ROOM DETAIL PHOTOS =====
        // These appear ONLY in "All Photos" - NOT in "Rooms" filter
        { id: 9, src: baphuthii, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 8, src: baphuthi, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 16, src: blackshower, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 21, src: bathtub, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 13, src: makhoakhoa, category: 'rooms', title: '', showInRooms: false, showTitle: false },    
        { id: 18, src: makholo, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 11, src: baphuthimakhoakhoa, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 12, src: makhoa, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 14, src: makhoablack, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 15, src: blackdoor, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 17, src: makholokoebed, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 24, src: bedside, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 22, src: basia, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 19, src: makholokoetv, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 20, src: basiatv, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 23, src: tv, category: 'rooms', title: '', showInRooms: false, showTitle: false },
        { id: 10, src: bap, category: 'rooms', title: '', showInRooms: false, showTitle: false },
    ];

    const categories = [
        { id: 'all', label: 'All Photos' },
        { id: 'rooms', label: 'Rooms' },
        { id: 'exterior', label: 'Guest House' },
    ];

    // Filter logic
    const getFilteredImages = () => {
        if (filter === 'all') {
            return images; // Show ALL images
        } else if (filter === 'rooms') {
            // Only show images with showInRooms: true
            return images.filter(img => img.showInRooms === true);
        } else if (filter === 'exterior') {
            // Only show images with showInExterior: true
            return images.filter(img => img.showInExterior === true);
        }
        return images;
    };

    const filteredImages = getFilteredImages();

    const openLightbox = (image) => {
        setSelectedImage(image);
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setSelectedImage(null);
        document.body.style.overflow = 'auto';
    };

    // Handle keyboard escape key
    React.useEffect(() => {
        const handleEsc = (event) => {
            if (event.key === 'Escape') {
                closeLightbox();
            }
        };
        window.addEventListener('keydown', handleEsc);
        return () => {
            window.removeEventListener('keydown', handleEsc);
        };
    }, []);

    return (
        <div className="gallery-page">
            <Header />
            
            <section className="gallery-hero">
                <div 
                    className="gallery-hero-image"
                    style={{
                        backgroundImage: `linear-gradient(rgba(44,62,80,0.7), rgba(44,62,80,0.7)), url(${galleryHero})`
                    }}
                ></div>
                <div className="hero-content">
                    <h1>Gallery</h1>
                    <p>Explore Maison Mosh II through our photo collection</p>
                </div>
            </section>

            <section className="gallery-section">
                <div className="container">
                    <div className="gallery-filters">
                        {categories.map(cat => (
                            <button
                                key={cat.id}
                                className={`filter-btn ${filter === cat.id ? 'active' : ''}`}
                                onClick={() => setFilter(cat.id)}
                            >
                                {cat.label}
                            </button>
                        ))}
                    </div>

                    <div className="gallery-grid">
                        {filteredImages.map((image) => (
                            <div 
                                key={image.id} 
                                className="gallery-item"
                                onClick={() => openLightbox(image)}
                            >
                                <img src={image.src} alt={image.title || 'Gallery image'} loading="lazy" />
                                <div className="gallery-overlay">
                                    {/* Only show title if showTitle is true AND filter is not 'all' */}
                                    {filter !== 'all' && image.showTitle && (
                                        <span className="gallery-title">{image.title}</span>
                                    )}
                                    <span className="gallery-icon">🔍</span>
                                </div>
                            </div>
                        ))}
                    </div>

                    {filteredImages.length === 0 && (
                        <div className="no-images">
                            <p>No images found in this category.</p>
                        </div>
                    )}
                </div>
            </section>

            {selectedImage && (
                <div className="lightbox" onClick={closeLightbox}>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <button className="lightbox-close" onClick={closeLightbox}>×</button>
                        <img src={selectedImage.src} alt={selectedImage.title || 'Gallery image'} />
                        {filter !== 'all' && selectedImage.showTitle && (
                            <p className="lightbox-title">{selectedImage.title}</p>
                        )}
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default Gallery;